import { debounce } from "lodash";
import { useRef, useState } from "react";

const useHover = () => {
  const [regionClass, setRegionClass] = useState<string | null>(null);
  const debounceClassRef = useRef(
    debounce((className: string | null) => {
      setRegionClass(className);
    }, 150)
  );

  const addClass = (className: string) => {
    debounceClassRef.current(`p-${className} highlight-visualization`);
  };

  const removeClass = () => {
    debounceClassRef.current(null);
  };

  return {
    regionClass,
    addClass,
    removeClass
  };
};

export default useHover;
